import { useQuery } from 'react-query'
import './index.scss'
import { getMobileLocations } from '../../services/calls/positions'
import { useContext, useEffect, useRef, useState } from 'react'
import FlotiMap from '../../components/FlotiMap'
import LiveMap_Sidebar from './sidebar'
import UserContext from '../../contexts/UserContext/context'
import { initial_sidebar } from '../../contexts/SidebarContext/reducer'
import { useSidebar } from '../../hooks/useSidebar'
import { ICON } from '../../components/Icon/data'
import { FlotiMapRef } from '../../components/FlotiMap/type'
import { useTranslation } from 'react-i18next'
import Icon from '../../components/Icon'
import { COLOR, COOKIE } from '../../data/variables'
import { useCookies } from '../../hooks/useCookies'

const LiveMap = () => {
  const { user } = useContext(UserContext)
  const sidebarRef = useRef()
  const mapRef = useRef<FlotiMapRef>()

  const { updateSidebar } = useSidebar()
  const { t } = useTranslation()

  const { getCookie, setCookie } = useCookies()
  const defaultFleet = getCookie(COOKIE.LIVEMAP_FLEET_SELECTION)
    ? Number(getCookie(COOKIE.LIVEMAP_FLEET_SELECTION))
    : user?.main_fleet ?? user?.available_fleets?.[0]?.fleetid
  const [fleet, setFleet] = useState<number>(defaultFleet)

  const { data, isLoading } = useQuery({
    queryKey: 'getMobileLocations',
    queryFn: () => getMobileLocations(fleet),
    refetchInterval: 5000
  })

  useEffect(() => {
    if (fleet) {
      const fleetName = user?.available_fleets?.find((f) => f.fleetid === Number(fleet))?.name ?? t('Unknown fleet')
      mapRef?.current?.setInfoDisplay({
        label: (
          <>
            <Icon icon={ICON.CARS} color={COLOR.WHITE} />
            {t('Fleet')}
          </>
        ),
        content: fleetName
      })
    }
  }, [fleet])
  
  useEffect(() => {
    updateSidebar({
      content: (
        <LiveMap_Sidebar
          ref={sidebarRef}
          mapRef={mapRef}
          onFleetChange={(val) => {
            setFleet(val)
            setCookie(COOKIE.LIVEMAP_FLEET_SELECTION, val.toString())
          }}
          defaultFleet={fleet}
        />
      ),
      isOpen: true,
      width: 660,
    })

    return () => {
      updateSidebar(initial_sidebar)
    }
  }, [])

  useEffect(() => {
    if (sidebarRef?.current) sidebarRef?.current?.setIsLoading(isLoading)
  }, [isLoading, sidebarRef.current])

  useEffect(() => {
    if (data && sidebarRef.current) {
      sidebarRef.current.setData(data.mobile_locations)
      const mapPoints = data.mobile_locations?.map((point) => {
        const { lat, lon, mobile_globalid, icon_color, mobileid, heading, icon } = point
        const marker = icon?.split('_')?.[0] ?? 'arrow'
        return {
          lat,
          lon,
          heading,
          name: mobile_globalid,
          icon: marker === 'arrow' ? ICON.MAP_MARKER : ICON.MARKER_CIRCLE,
          color: icon_color,
          id: mobileid
        }
      })
      mapRef?.current?.setPoints(mapPoints)
    }
  }, [data, sidebarRef.current])

  return (
    <div className="LiveMap">
      <FlotiMap ref={mapRef} />
    </div>
  )
}

export default LiveMap
